<template>
  <div class="c-app">
    <TheSidebar/>
    <CWrapper>
      <TheHeader/>
      <div class="c-body">
        <main class="c-main">
          <CContainer fluid>
            <transition name="fade">
              <router-view></router-view>
            </transition>
          </CContainer>
        </main>
        <TheFooter/>
      </div>
    </CWrapper>
  </div>
</template>

<script>
import TheSidebar from './TheSidebar'
import TheHeader from './TheHeader'
import TheFooter from './TheFooter'
import moment from "moment"

export default {
  name: 'TheContainer',
  components: {
    TheSidebar,
    TheFooter, TheHeader
  },
  created() {
    if (localStorage.getItem('access_token')) {
      this.$store.commit('setIdToken', localStorage.getItem('access_token'))
      this.$store.commit('setRole', localStorage.getItem('role'))
      localStorage.setItem('is_auth', true)
      if (localStorage.getItem('expired_at') < moment().unix()) {
        this.signOut()
      }
    } else {
      this.signOut()
    }
  },
  methods: {
    signOut() {
      localStorage.removeItem('access_token');
      localStorage.removeItem('expired_at');
      localStorage.setItem('is_auth', false);
      this.$router.push('/login')
    }
  },
}
</script>

<style scoped>
.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.3s;
}
.fade-enter,
.fade-leave-to {
  opacity: 0;
}
</style>
